import { useParams } from "react-router-dom";

export const HambourgInvitation = () => {
  const { id } = useParams();
  const path = '/newsletter/versions/hambourg_invitation.html';
  return (
    <iframe
      title={"Hambourg Invitation"}
      src={path}
      style={{ width: "100vw", height: "100vh" }}
    />
  );
};
